import {Component, OnInit, ViewChild} from '@angular/core';
import {DisplayedColumnInf} from '../../interfaces/common/table/displayed-column-inf';
import {ServerPageRequest} from '../../classes/common/table/server-page-request';
import {UserPrivilegeService} from '../../services/common/user-privilege/user-privilege.service';
import {PageEvent} from '@angular/material/paginator';
import {NodeApiService} from '../../services/api/network/online/node/node-api.service';
import {ConnectionApiService} from '../../services/api/network/online/connection/connection-api.service';
import {RoutingInterfaceApiService} from '../../services/api/network/online/routing-interface/routing-interface-api.service';
import * as _ from 'lodash';
import {ConnectionsSearchComponent} from './connections-search/connections-search.component';
import {TableColumnsConfigurationDialogComponent} from '../../dialogs/table-columns-configuration-dialog/table-columns-configuration-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {QualityBasedRoutingApiService} from '../../services/api/settings/routing/quality-based-routing/quality-based-routing-api.service';
import {IpProfileApiService} from '../../services/api/network/online/ip-profile/ip-profile-api.service';
import {MediaRealmApiService} from '../../services/api/network/online/media-realm/media-realm-api.service';
import {LogicalConjunctionService} from '../../services/common/logical-conjunction/logical-conjunction.service';
import {SnackBarService} from '../../services/common/snack-bar/snack-bar.service';
import {NetworkApiService} from '../../services/api/network/online/network/network-api.service';
import {ConnectionsStatusPipe} from '../../pipes/connection-status/connections-status.pipe';
import {ConnectionEdgeStatusPipe} from './connection-edge-status.pipe';
import {ArmTableComponent} from '../../components/arm-table/arm-table.component';
import {LoaderService} from '../../services/common/loader-service/loader.service';
import Search from '../../utils/search';
import {SearchTermDefinitionInf} from '../../interfaces/common/search/search-term-definition-inf';
import {ConnectionDialogService} from './connections-dialog/connection-dialog.service';

@Component({
    selector: 'connections',
    templateUrl: './connections.component.html',
    styleUrls: ['./connections.component.scss']
})
export class ConnectionsComponent implements OnInit {

    connectionsSearchComponent = ConnectionsSearchComponent;

    search: any = {};
    searchData = {};
    operatorStateOptions = [
     {text: 'Available', value: 'AVAILABLE'},
      {text: 'Unavailable', value: 'UNAVAILABLE'}
    ];

    qualityOptions = [
      {text: 'Bad', value: 'BAD'},
      {text: 'Fair', value: 'FAIR'},
      {text: 'Good', value: 'GOOD'},
      {text: 'Unknown', value: 'UNKNOWN'}
    ];
    data = {elements: [], totalElements: 0};
    selection;
    isMultipleSelection = true;
    displayedColumns: Array<DisplayedColumnInf> = [
        {name: 'status', display: 'Status', selected: true, width: 200, transformer: ConnectionsStatusPipe},
        {name: 'name', display: 'Name', selected: true, width: 200},
        {name: 'srcNode', display: 'Node 1', selected: true, width: 200},
        {name: 'srcRoutingInterface', display: 'Routing IF-1', selected: true, width: 200},
        {name: 'edgesStatus', display: 'Edges Status', selected: true, width: 200, transformer: ConnectionEdgeStatusPipe},
        {name: 'destNode', display: 'Node 2', selected: true, width: 200},
        {name: 'destRoutingInterface', display: 'Routing IF-2', selected: true, width: 200},
        {name: 'weight', display: 'Weight', selected: true, width: 200},
        {name: 'result', display: 'Quality', selected: true, width: 200}
    ];

    searchTerms: SearchTermDefinitionInf[] = [
      {term: 'operativeState', operator: '=', displayName: 'Operative State',
        displayValue: Search.getOptionValue(this.operatorStateOptions)},
      {term: 'quality', operator: '=', displayName: 'Quality', displayValue: Search.getOptionValue(this.qualityOptions)},
      {term: 'connectionName', operator: '=', displayName: 'Connection Name'},
      {term: 'ceName', operator: '=', displayName: 'Connection Edge Name'},
    ];

    serverPageRequest: ServerPageRequest = new ServerPageRequest({
        pageIndex: 0,
        pageSize: 25,
        length: 0
    });

    @ViewChild(ArmTableComponent) armTable;

    isUnauthorized: boolean;

    nodes;
    routingInterface;
    ipProfiles;
    mediaRealm;
    advancedConditions;



    constructor(private userPrivilege: UserPrivilegeService,
                public dialog: MatDialog,
                private snackBarService: SnackBarService,
                private connectionApiService: ConnectionApiService,
                private nodeApiService: NodeApiService,
                private qualityBasedRoutingApiService: QualityBasedRoutingApiService,
                private logicalConjunctionService: LogicalConjunctionService,
                private routingInterfaceApiService: RoutingInterfaceApiService,
                private ipProfilesApiService: IpProfileApiService,
                private mediaRealmApiService: MediaRealmApiService,
                private networkApiService: NetworkApiService,
                private connectionDialogService: ConnectionDialogService,
                private loaderService: LoaderService) {
    }

    ngOnInit(): void {
        this.isUnauthorized = !this.userPrivilege.isAuthorized();
        this.refresh();
    }

    onSelection(selection: any): void {
        this.selection = selection;
    }

    pageChanged(pageInfo: PageEvent): void {
        this.serverPageRequest = new ServerPageRequest(pageInfo);

        this.refreshItems();
    }

    onSearch(data): void {
      this.armTable.firstPage();
      this.serverPageRequest.firstPage();
      this.search = data;
      this.refreshItems();
    }

    refresh(): void {
        const params = {...this.search, ...this.serverPageRequest};
        this.loaderService.showMainContainer();
        Promise.all([
            this.connectionApiService.getConnections(params),
            this.nodeApiService.getNodesForMap(),
            this.routingInterfaceApiService.getRoutingInterfacesForMap(),

            this.qualityBasedRoutingApiService.getQualityBasedRoutingSettings().toPromise(),
            this.ipProfilesApiService.getIpProfiles().toPromise(),
            this.mediaRealmApiService.getMediaRealm().toPromise()
        ]).then((data) => {
            const nodesOptions = _.cloneDeep(data[1]);
            const routingInterfaceOptions = _.cloneDeep(data[2]);
            const ipProfilesOptions = _.cloneDeep(data[4]);
            const mediaRealmOptions = _.cloneDeep(data[5]);

            this.nodes = nodesOptions;
            this.routingInterface = routingInterfaceOptions;
            this.ipProfiles = ipProfilesOptions;
            this.mediaRealm = mediaRealmOptions;

            this.addAdditionalData(data[0], data[1], data[2]);
            this.setSearchOptions();
            this.data = data[0];
            this.advancedConditions = data[3];
            this.loaderService.hideMainContainer();
        }).catch(() => {
            console.log('Exception was thrown in refresh function');
            this.loaderService.hideMainContainer();
        });
    }

    private addAdditionalData(connections, nodes, rIs): void {
        nodes = _.keyBy(nodes, 'id');
        rIs = _.keyBy(rIs, 'id');

        connections.elements = this.modifyConnectionsForGrid(connections.elements, nodes, rIs);
    }

    private modifyConnectionsForGrid(connections, nodes, rIs): any {
        const modifyNameToSupportConnectionTemplate = (connection) => {
            let leftArrowColor;
            let rightArrowColor;

            leftArrowColor = (connection.type === 'NODE_TO_THIRD_PARTY') ? 'grey' :
                (connection.connections[1].operState === 'AVAILABLE' ? 'green' : 'red');
            rightArrowColor = connection.connections[0].operState === 'AVAILABLE' ? 'green' : 'red';
            return {left: leftArrowColor, right: rightArrowColor};
        };

        return connections.map((connection) => {
            connection.srcNode = nodes[connection.connections[0].srcNodeId].name;
            connection.destNode = nodes[connection.connections[0].destNodeId].name;
            connection.srcRoutingInterface = rIs[connection.connections[0].srcRoutingInterface].name;
            connection.destRoutingInterface = rIs[connection.connections[0].destRoutingInterface].name;
            connection.status = this.getConnectionStatus(connection);
            connection.edgesStatus = modifyNameToSupportConnectionTemplate(connection);

            return connection;
        });
    }

    private getConnectionStatus(connection): string {
        if (connection.type === 'NODE_TO_THIRD_PARTY') {
            return connection.connections[0].operState === 'AVAILABLE' ? 'ok' : 'not_ok';
        } else {
            return connection.connections[0].operState === 'AVAILABLE' && connection.connections[1].operState === 'AVAILABLE' ? 'ok' : 'not_ok';
        }
    }

    private setSearchOptions(): void {
        this.searchData = {
          operatorStateOptions: this.operatorStateOptions,
          qualityOptions: this.qualityOptions
        };
    }

    addItem(): void {
        this.connectionDialogService.add({}, this.nodes, this.routingInterface, this.ipProfiles,
          this.mediaRealm, this.advancedConditions, () => {
            this.refresh();
        });
    }

    editItem(): void {
        this.connectionDialogService.edit(this.selection[0], this.nodes,
          this.routingInterface, this.ipProfiles, this.mediaRealm, this.advancedConditions, () => {
              this.refresh();
        });
    }

    removeItem(): void {
        this.connectionDialogService.delete(this.selection, () => {
            this.refresh();
        });
    }

    isSingleSelection(): boolean {
        return this.selection && this.selection.length === 1;
    }

    isAnySelection(): boolean {
        return  this.selection && this.selection.length > 0;
    }

    syncTopology(): void {
        this.networkApiService.syncTopology().then(() => {
            this.snackBarService.display(`Topology synchronization started`);
        });
    }

    openColumnsConfiguration(): void {
        const dialogRef = this.dialog.open(TableColumnsConfigurationDialogComponent, {
            width: '350px',
            data: {
                columns: this.displayedColumns
            }
        });

        dialogRef.componentInstance.onApply.subscribe(() => {
            dialogRef.close();
        });
    }

    private refreshItems(): void {
        const params = {...this.search, ...this.serverPageRequest};

        Promise.all([
            this.connectionApiService.getConnections(params),
            this.nodeApiService.getNodesForMap(),
            this.routingInterfaceApiService.getRoutingInterfacesForMap(),
        ]).then((data) => {
            this.addAdditionalData(data[0], data[1], data[2]);
            this.data = data[0];
        }).catch((error) => {
            console.log(`Exception was thrown in refresh connections, reason: ${error}`);
        });
    }
}
